import React from 'react';
import { ClientApiProps } from '../../common';
import { AssessorDocumenation } from './Documenation';
import { Assessments } from './Assessments';
import { Documentation } from '../../api';

export interface AssessorPageProps extends ClientApiProps {
  documenation: Documentation[];
  isAssessor: boolean;
}

export const AssessorPage: React.FC<AssessorPageProps> = (props) => {
  return (
    <>
      <AssessorDocumenation {...props} documenation={props.documenation} />
      <Assessments {...props} isAssessor={props.isAssessor} />
    </>
  );
};
